import type { ReactNode } from "react";

import { Modal } from "@similarweb/ui-components";

import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";

import {
    CONFIRMATION_MODAL_STYLES,
    StyledConfirmationModalContent,
    StyledConfirmationModalInner,
    StyledConfirmationModalTitle,
} from "./styles";

type ConfirmationModalProps = {
    isOpened: boolean;
    titleKey: string;
    children: ReactNode;
    dataAutomation?: string;
};

export const ConfirmationModal = ({
    isOpened,
    titleKey,
    children,
    dataAutomation = "si-confirmation-modal",
}: ConfirmationModalProps) => {
    return (
        <Modal
            data-automation={dataAutomation}
            isOpen={isOpened}
            shouldCloseOnEsc
            shouldCloseOnOverlayClick={false}
            customStyles={CONFIRMATION_MODAL_STYLES}
        >
            <StyledConfirmationModalContent>
                <StyledConfirmationModalInner>
                    <I18n
                        element={StyledConfirmationModalTitle}
                        translatable={{ key: titleKey }}
                    />

                    {children}
                </StyledConfirmationModalInner>
            </StyledConfirmationModalContent>
        </Modal>
    );
};
